// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { LoginAuthLoginEmailPostMutationRequest, LoginAuthLoginEmailPostMutationResponse, LoginAuthLoginEmailPost401, LoginAuthLoginEmailPost422, LoginAuthLoginEmailPost423 } from "../models/emailAuthController/LoginAuthLoginEmailPost.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";
import type { MutationObserverOptions, QueryClient } from "@tanstack/vue-query";
import type { MaybeRefOrGetter } from "vue";
import { loginAuthLoginEmailPost } from "../client/loginAuthLoginEmailPost.ts";
import { useMutation } from "@tanstack/vue-query";

export const loginAuthLoginEmailPostMutationKey = () => [{ url: '/auth/login/email' }] as const

export type LoginAuthLoginEmailPostMutationKey = ReturnType<typeof loginAuthLoginEmailPostMutationKey>

/**
 * @description Login with email or username and password.
 * Sets session cookie on success.
 * @summary Login
 * {@link /auth/login/email}
 */
export function useLoginAuthLoginEmailPost<TContext>(options: 
{
  mutation?: MutationObserverOptions<LoginAuthLoginEmailPostMutationResponse, ResponseErrorConfig<LoginAuthLoginEmailPost401 | LoginAuthLoginEmailPost422 | LoginAuthLoginEmailPost423>, {data: MaybeRefOrGetter<LoginAuthLoginEmailPostMutationRequest>}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<LoginAuthLoginEmailPostMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions?.mutationKey ?? loginAuthLoginEmailPostMutationKey()

          return useMutation<LoginAuthLoginEmailPostMutationResponse, ResponseErrorConfig<LoginAuthLoginEmailPost401 | LoginAuthLoginEmailPost422 | LoginAuthLoginEmailPost423>, {data: LoginAuthLoginEmailPostMutationRequest}, TContext>({
            mutationFn: async({ data }) => {
              return loginAuthLoginEmailPost(data, config)
            },
            mutationKey,
            ...mutationOptions
          }, queryClient)
      
}